import {
  TASKPANE_API_ENDPOINTS,
  getApiAuthCredentials,
  createApiHeaders,
  createApiFetchOptions,
  createApiUrl,
} from "../services/apiConfig";
import logger from "../../logger";

export const fetchAllCompanies = async () => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.ALL_COMPANIES);
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const data = await response.json();

    if (!data) {
      throw new Error("No data returned from API");
    }

    let companiesArray = [];
    if (Array.isArray(data)) {
      companiesArray = data;
    } else if (data.data && Array.isArray(data.data)) {
      companiesArray = data.data;
    } else if (data.companies && Array.isArray(data.companies)) {
      companiesArray = data.companies;
    } else if (data && typeof data === "object") {
      companiesArray = [data];
    }

    return companiesArray;
  } catch (error) {
    logger.error("Error fetching companies:", error);
    throw error;
  }
};

export const fetchSelectedCompany = async (companyId) => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.COMPANIES_BY_ID, {
      companyId: companyId.trim(),
    });
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const result = await response.json();

    if (!result) {
      throw new Error("No data returned from API");
    }

    let companyObject = null;

    if (result && typeof result === "object") {
      if (result.data && typeof result.data === "object" && !Array.isArray(result.data)) {
        companyObject = result.data;
      } else if (result.data && Array.isArray(result.data) && result.data.length > 0) {
        companyObject = result.data[0];
      } else if (Array.isArray(result) && result.length > 0) {
        companyObject = result[0];
      } else if (typeof result === "object" && !Array.isArray(result) && !result.data) {
        companyObject = result;
      }
    }

    if (!companyObject || typeof companyObject !== "object" || Array.isArray(companyObject)) {
      throw new Error("No company data found in API response");
    }

    return companyObject;
  } catch (error) {
    logger.error("Error fetching selected company:", error);
    throw error;
  }
};
